export default "__VITE_ASSET__BCcCBIyk__"